export default "__VITE_ASSET__BL2Di_MO__"